( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('KeywordCustomService', KeywordCustomService);

    KeywordCustomService.$inject = ['$http'];

    function KeywordCustomService($http) {
        return {
            returnKeywordsByType: returnKeywordsByType,
            returnMinifiedKeywordsByType: returnMinifiedKeywordsByType,
            returnKeywordByTypeAndKeyword: returnKeywordByTypeAndKeyword,
            returnSearchKeywords: returnSearchKeywords
        };

        function returnSearchKeywords(query) {
            var url = "api/_search/keywords?query=" + query;
            return $http.get(url);
        }

        function returnKeywordsByType(type) {
            var url = "api/keywords/type/" + type;
            return $http.get(url);
        }

        function returnMinifiedKeywordsByType(type) {
            var url = "api/keywords/minified/type/" + type;
            return $http.get(url);
        }

        function returnKeywordByTypeAndKeyword(type, keyword) {
            var url = "api/keyword?type=" + type + "&name=" + keyword;
            return $http.get(url);
        }
    }
})();
